export default {
  SET_UI_FLAG: 'SET_UI_FLAG',
  CLEAR_ENTRIES: 'CLEAR_ENTRIES',
  SET_ENTRIES: 'SET_ENTRIES',
  ADD_ENTRY: 'ADD_ENTRY',
  UPDATE_ENTRY: 'UPDATE_ENTRY',
  REMOVE_ENTRY: 'REMOVE_ENTRY',
};
